import { SxProps, Theme } from "@mui/material";

export const content: SxProps<Theme> = (theme) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(3),
});

export const text: SxProps<Theme> = {
  display: "flex",
  alignItems: "baseline",
};
